import {Component, OnDestroy} from '@angular/core';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {InputTextModule} from 'primeng/inputtext';
import {FloatLabelModule} from 'primeng/floatlabel';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Router, RouterModule} from '@angular/router';
import {TranslationPipe} from '../../pipes/translation.pipe';
import {PasswordModule} from 'primeng/password';
import {IdentityClient, LoginRequestDto, LoginResponseDto, SwaggerResponse} from '../../api/api-client';
import {AuthService} from '../../services/auth.service';
import {SubscriptionManager} from '../../services/subscription-manager.service';


@Component({
  selector: 'app-login',
  imports: [CardModule, ReactiveFormsModule, InputTextModule, PasswordModule, FloatLabelModule, ButtonModule, RouterModule, TranslationPipe],
  providers: [SubscriptionManager],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm = new FormGroup({
    username: new FormControl<string>(''),
    password: new FormControl<string>('')
  });

  constructor(
    private readonly loginService: IdentityClient,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly subscriptionManager: SubscriptionManager // ApiService injected
  ) {
  }

  onSubmit() {
    let data = {
      username: this.loginForm.value.username ?? "",
      password: this.loginForm.value.password ?? "",
      language: navigator.language.substring(0, 2)
    }
    this.subscriptionManager.call(
      this.loginService.login(<LoginRequestDto>data),
      (x: SwaggerResponse<LoginResponseDto>) => {
        this.authService.saveToken(x.result);
        this.router.navigate(["loggedin/dashboard"]);
      }
    );
  }
}
